<template>
  <div>
    <sidebar :id="id" :menu="menu" :submenu="submenu" />
    <v-container fluid>
      <template v-if="display">
        <LoadData :modify="modify" />
      </template>
      <template v-else>
        <v-alert dense outlined type="error"> Not Authorized ! </v-alert>
      </template>
    </v-container>
  </div>
</template>



<script>
import Sidebar from "../../components/Sidebar.vue";
import LoadData from "../../components/Transaksi/returStock/loadData.vue"
import { mapGetters } from "vuex";

export default {
  name: "Transaksi_Retur_Stock",

  components: { Sidebar, LoadData },

  metaInfo: {
    title: "Rhea Admin",
    titleTemplate: "%s - TP Gd. Retur ke Gd. Stock",
    htmlAttrs: {
      lang: "id",
      amp: true,
    },
  },

  data: () => ({
    id: "1",
    menu: "Transaksi",
    submenu: " -> TP Gd. Retur ke Gd. Stock",
    display: true,
    modify: true,
  }),

  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user",
    }),
  },

  created() {
    if (this.user.dataPermission.includes("retur_stock.display")) {
      this.display = true;
    } else {
      this.display = false;
    }
    if (this.user.dataPermission.includes("retur_stock.modify")) {
      this.modify = true;
    } else {
      this.modify = false;
    }
  },
};
</script>